import { PaymentMethod } from '@app/states/product/constants/payment-method.const';

export const PAYMENT_METHOD_TITLE_MAP: Map<PaymentMethod, string> = new Map<PaymentMethod, string>([
  [PaymentMethod.SBP, 'Система быстрых платежей'],
]);
